import type { LucideIcon } from 'lucide-react';
import {
    BarChart3,
    Boxes,
    ClipboardList,
    HardDrive,
    Home,
    MapPin,
    Megaphone,
    Package,
    Ticket,
    Users,
    Workflow,
} from 'lucide-react';

export const LEGACY_ADMIN_URL = import.meta.env.VITE_LEGACY_ADMIN_URL || 'https://admin.fastfresh.ru';

export interface NavItem {
    label: string;
    icon: LucideIcon;
    /** Маршрут новой админки. */
    to?: string;
    /** Внешняя ссылка (старая админка, Redash). */
    href?: string;
    /** Показывать в нижнем таббаре на телефоне (не больше 4 — пятый слот у «Ещё»). */
    tab?: boolean;
    /** Короткая подпись для таббара: на 375px влезает ~9 символов. */
    short?: string;
}

export function isNavActive(pathname: string, to: string) {
    return to === '/' ? pathname === '/' : pathname === to || pathname.startsWith(`${to}/`);
}

export const NAV_MAIN: NavItem[] = [
    { label: 'Главная', icon: Home, to: '/', tab: true },
    { label: 'Постаматы', icon: Boxes, to: '/lockers', tab: true },
    { label: 'Промокоды', short: 'Промо', icon: Ticket, to: '/promo-codes', tab: true },
    { label: 'Продукты', icon: Package, to: '/products' },
    { label: 'Локации', icon: MapPin, to: '/locations' },
    { label: 'Пользователи', short: 'Люди', icon: Users, to: '/users', tab: true },
    { label: 'Рассылки', icon: Megaphone, to: '/notifications' },
];

// Экраны, завязанные на новую модель статусов (заказы, переходы), переносятся после неё.
// До тех пор — ссылка в старую админку на тот же путь.
export const NAV_LEGACY: NavItem[] = [
    { label: 'Заказы', icon: ClipboardList, href: `${LEGACY_ADMIN_URL}/orders` },
    { label: 'Статусы', icon: Workflow, href: `${LEGACY_ADMIN_URL}/statuses` },
    { label: 'Диск', icon: HardDrive, href: `${LEGACY_ADMIN_URL}/disk` },
    { label: 'Redash', icon: BarChart3, href: 'https://redash.fastfresh.ru' },
];
